import type { SchemaViewerFormContextValue } from "./schema-viewer-form.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "SchemaViewerFormContext",
  providerName: "SchemaViewerFormProvider",
};

export const SchemaViewerFormContext =
  createContext<SchemaViewerFormContextValue | null>(null);

export const useSchemaViewerFormContext = () => {
  const contextValue = useContext(SchemaViewerFormContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
